module.exports = __webpack_public_path__ + "fonts/MyriadPro-CondIt.e94308c.woff2";